class BlazeCarousel extends HTMLElement {
  constructor() {
    super()

    this.el = this.querySelector('.blaze-slider');  
    this.init();
  }

  init() {
    return new BlazeSlider(this.el, {
      all: {
        enableAutoplay: true,
        autoplayInterval: 3000,
        transitionDuration: 1000,
        slidesToShow: 7,
        slideGap: '5rem'
      },
      '(max-width: 1024px)': {
        slidesToShow: 5,
      },
      '(max-width: 900px)': {
        slidesToShow: 5,
      },
      '(max-width: 500px)': {
        slidesToShow: 3,
      },
    })
  }
}

customElements.define('blaze-carousel', BlazeCarousel);

if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.buyButton = this.querySelector('button');
      this.buyButton?.addEventListener('click', this.addToCart.bind(this));
    }

    addToCart(evt) {
      evt.preventDefault();
      const buyButton = this.buyButton;
      buyButton.classList.add('disabled');
      let formData = {'items': []};
      let _id = this.form.querySelector('input[name="id"]').value;

      console.log(_id)
      if(_id === '17007722561606017') {
        _id = 41494472720455;
      }
      formData.items.push({
        "id": _id,
        "quantity": parseInt(this.form.querySelector('input[name="quantity"]').value)
      });

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        this.buyButton.classList.remove('disabled');
        if(location.href.indexOf('/products/') >= 0) {
          window.buildCart();
          document.body.classList.toggle('sidecart-open');
        } else {
          location.href = "/checkout";
        }
      })
      .catch((error) => {
        this.buyButton.classList.remove('disabled');
        console.error('Error:', error);
      });
    }
  }

  customElements.define('product-form', ProductForm);
}

if (!customElements.get('product-bundle-form')) {
  class ProductBundleForm extends HTMLElement {
    constructor() {
      super();
      
      this.buyButton = this.querySelector('button');
      this.items = this.buyButton.dataset.items.split(',');
      this.buyButton?.addEventListener('click', this.addToCart.bind(this));
    }

    addToCart(evt) {
      evt.preventDefault();
      const buyButton = this.buyButton;
      buyButton.classList.add('disabled');

      let formData = {'items': []};
      this.items.forEach((item, index) => {
        formData.items.push({
          "id": item.split(':')[0],
          "quantity": parseInt(item.split(':')[1])
        });
      });

      this.buyButton.innerText = 'Adding...'
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        this.buyButton.innerText = 'redirecting to checkout'
        location.href = "/checkout";
      })
      .catch((error) => {
        this.buyButton.classList.remove('disabled');
        console.error('Error:', error);
      });
    }
  }

  customElements.define('product-bundle-form', ProductBundleForm);
}

const allStarRatingBadges = document.querySelectorAll('.oke-review-trigger');

allStarRatingBadges.forEach((ratingbadge) => {
  ratingbadge.addEventListener('click', function(e){
    if (document.body.dataset.pageType !== 'product') {
      location.href = "/pages/reviews";
    }
  });
});